import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const formList = [
  {
    name: "id",
    label: "ID",
    maxLength: 20,
    schema: {
      required: TkPropertyMessageGet("TKMSG_SCR0043E"),
      pattern: {
        value: /^[!-~]*$/,
        message: TkPropertyMessageGet("TKMSG_SCR0056E"),
      },
      maxLength: {
        value: 20,
        message: TkPropertyMessageGet("TKMSG_SCR0046E", "20"),
      },
    },
  },
  {
    name: "password",
    label: "パスワード",
    maxLength: 64,
    schema: {
      required: TkPropertyMessageGet("TKMSG_SCR0043E"),
      pattern: {
        value: /^[!-~]*$/,
        message: TkPropertyMessageGet("TKMSG_SCR0056E"),
      },
      minLength: {
        value: 6,
        message: TkPropertyMessageGet("TKMSG_SCR0045E", "6"),
      },
      maxLength: {
        value: 24,
        message: TkPropertyMessageGet("TKMSG_SCR0046E", "24"),
      },
    },
  },
];

export { formList };
